<template>
  <div>
      <el-button type="danger" size="mini" @click="dialogFormVisible=true">Excel导入</el-button>
      <input type="file" @change="ImportExcel" ref="xlsxbutton" accept=".xlsx" style="display:none">
      <el-dialog title="电子表格导入" :visible.sync="dialogFormVisible" :show-close="false" width="600px" append-to-body>
          <div>
              <div style="padding:10px;font-size:15px;font-weight: bold;">表格导入格式如下所示:</div>
              <div>
                <table style="width:100%;"  border="0" cellspacing="0" cellpadding="0" class="table-c">
                    <tr>
                      <td v-for="(item,index) in ths" :key="index">{{item}}</td>
                    </tr>
                    <tr><td v-for="(item,index) in ths" :key="index">...</td></tr>
                </table>
              </div>
              <!-- <div><span style="padding:10px;" v-for="(item,index) in ths" :key="index">{{item}}</span></div> -->
              <div style="padding:20px 10px 10px 10px;font-size:12px;color:#580202;">温馨提示：只读取电子表格中的第一个sheet，确保excel第一行的标题列中存在以上要求必需列,顺序可以打乱！</div>
          </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible=false">取 消</el-button>
            <el-button type="primary" @click="changefile()">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
    props:{
        par:{
            type:Object,
            default:{}
        },
        classname:{
            type:String,
            default:''
        },
        okupload:{
            type:Function,
            default:null
        }
    },
    data(){
        return{
            dialogFormVisible:false,
            ths:{}
        }
    },
    watch: {
        'classname'(to, from) {
            this.getxlsx();
        }
    },
    mounted(){
        this.getxlsx();
    },
    methods:{
        getxlsx(){
            let that = this
            that.GetData('GetImportXLSX',{CLASSNAME:that.classname},function(res){
                let xlsx = res.data.xlsx
                that.ths = []
                for (var val in xlsx) {
                    that.ths.push(xlsx[val])
                }
            },function(err){
                console.log(err)
            })
        },
        changefile: function () {
            this.$refs.xlsxbutton.value = "";
            this.$refs.xlsxbutton.click();
        },
        ImportExcel(e) {
            const that = this
            var files = e.target.files || e.dataTransfer.files;
            if (files.length > 1) {
                that.$alert("一次只能上传1个文件。", {
                title: "错误"
                });
                this.$refs.xlsxbutton.value = "";
                return;
            }
            that.dialogFormVisible = false
            that.PostFile('importXLSX', that.par, files[0], res => {
                if (res.data.error_code == 0) {
                    this.$message({
                    message: '成功导入'+res.data.importCount+'条数据!',
                    type: 'success'
                    });
                    that.okupload()
                } else {
                this.$alert(res.data.message,'导入失败!',{
                    confirmButtonText:'确定',
                    type: 'warning',
                    callback: action => {}
                });
                }
            }, err => {
                this.$alert(err,'导入失败!',{
                    confirmButtonText:'确定',
                    type: 'warning',
                    callback: action => {}
                });
            },process=>{
                console.log(process)
            })
        },
    }
}
</script>

<style scoped>
    .table-c {border-right:1px solid #ccc;border-bottom:1px solid #ccc} 
    .table-c td{border-left:1px solid #ccc;border-top:1px solid #ccc;padding:3px;} 
</style>>
